import { render, staticRenderFns } from "./observacoes.vue?vue&type=template&id=71fe3d9c&"
import script from "./observacoes.vue?vue&type=script&lang=js&"
export * from "./observacoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports